"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertOptions = void 0;
var uuid_1 = require("uuid");
var AlertOptions = /** @class */ (function () {
    function AlertOptions(data, id) {
        this.id = id || (0, uuid_1.v4)();
        this.alert = __assign({}, data);
    }
    AlertOptions.info = function (options) {
        return this.build('info', options);
    };
    AlertOptions.warning = function (options) {
        return this.build('warning', options);
    };
    AlertOptions.error = function (options) {
        return this.build('danger', options);
    };
    AlertOptions.success = function (options) {
        return this.build('success', options);
    };
    AlertOptions.build = function (variant, _a) {
        var id = _a.id, _b = _a.alert, alert = _b === void 0 ? {} : _b;
        var message = alert.message, actionLabel = alert.actionLabel, actionLink = alert.actionLink, actionHandler = alert.actionHandler;
        return new AlertOptions({
            show: true,
            variant: variant,
            message: message,
            actionLabel: actionLabel,
            actionHandler: actionHandler,
            actionLink: actionLink,
        }, id);
    };
    return AlertOptions;
}());
exports.AlertOptions = AlertOptions;
